// v49.1/v49.2 — AuthGate. Wraps a route's element; redirects
// unauthenticated users to /signin (preserving the attempted path in
// router state so SignInPage can bounce them back after auth). v49.2
// upgraded the loading state from a bare text string to a sidebar +
// topbar skeleton so the layout shift on hydration is minimal.

import { Navigate, useLocation } from "react-router";
import { useAuth } from "../AuthContext";
import { AuthLoadingSkeleton } from "@/features/shell/components/AuthLoadingSkeleton";

interface Props { children: React.ReactNode; }

export function AuthGate({ children }: Props) {
  const { status } = useAuth();
  const location   = useLocation();

  if (status === "loading")   return <AuthLoadingSkeleton />;
  if (status === "anonymous") return <Navigate to="/signin" replace state={{ from: location }} />;
  return <>{children}</>;
}
